import React from "react";
import { Confirm, Modal } from "semantic-ui-react";
import SecondaryBlueButton from "components/Buttons/SecondaryBlueButton";
import RedButton from "components/Buttons/RedButton";
import FilePreview from "../FilePreview";
import { b64toBlob } from "utils/file";

const ViewFilesModal = ({
	open,
	close,
	disabled,
	fileIndex,
	files,
	deleteFile,
	isNotOriginal = false,
	validateScanPrescription,
	validateQualityScanPrescription,
	unvalidateQualityScanPrescription,
	telesec,
	movePrescriptionScan,
	base64Pdf,
}) => {
	const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);
	if ((!files || files.length === 0) && !base64Pdf) {
		return <span></span>;
	} else {
		return (
			<>
				<Modal open={open} closeOnEscape closeOnDimmerClick onClose={close}>
					<Modal.Content>
						{base64Pdf && (
							<iframe
								id="fraDisabled"
								//Prevent download
								src={URL.createObjectURL(b64toBlob(base64Pdf, "application/pdf")) + "#toolbar=1"}
								title="Ordonnance renouvelable"
								name="Ordonnance renouvelable"
								style={{
									width: "100%",
									height: "80vh",
								}}
							></iframe>
						)}
						{!base64Pdf && (
							<FilePreview
								files={files}
								fileIndex={fileIndex}
								isModal
								validateScanPrescription={validateScanPrescription}
								deleteScanPrescription={deleteFile}
								validateQualityScanPrescription={validateQualityScanPrescription}
								unvalidateQualityScanPrescription={unvalidateQualityScanPrescription}
								telesec={telesec}
								movePrescriptionScan={movePrescriptionScan}
								disabled={disabled}
							/>
						)}
					</Modal.Content>

					<Modal.Actions>
						{deleteFile && !isNotOriginal && (
							<RedButton
								negative
								onClick={() => {
									setConfirmDeleteOpen(true);
								}}
								disabled={disabled}
							>
								Supprimer
							</RedButton>
						)}
						<SecondaryBlueButton
							negative
							onClick={() => {
								close();
							}}
						>
							Fermer
						</SecondaryBlueButton>
					</Modal.Actions>
				</Modal>
				<Confirm
					centered
					open={confirmDeleteOpen}
					content="Êtes-vous sûr de vouloir supprimer ce document ?"
					cancelButton="Non"
					confirmButton="Oui"
					onCancel={() => setConfirmDeleteOpen(false)}
					onConfirm={() => {
						deleteFile(files[fileIndex]);
						setConfirmDeleteOpen(false);
						close();
					}}
				/>
			</>
		);
	}
};

export default ViewFilesModal;
